import React from 'react';
import { Link } from 'react-router-dom';

const Keywords = () => {
  return (
    <section className="keyword">
      <div className="inner">
        <h2>よく検索されている<span>人気キーワード</span></h2>
        <ul>
          <li><Link to="/search-result?height[]=170&height[]=180">身長170cm以上</Link></li>
          <li><Link to="/search-result?age[]=30&age[]=40">30代〜40代</Link></li>
          <li><Link to="/search-result?college_type[]=PUBLIC&college_type[]=PRIVATE">大卒</Link></li>
          <li><Link to="/search-result?std_certified_only=TRUE">性病検査済み</Link></li>
          <li><Link to="/search-result?methods=SYRINGE">シリンジ法</Link></li>
          <li><Link to="/search-result?nationality=JAPANESE&race=JAPANESE">日本人</Link></li>
        </ul>
      </div>
    </section>
  );
}

export default Keywords;
